module.exports = __webpack_public_path__ + "static/media/island.111fd6c1.svg";